import { Phone, Mail } from "lucide-react";
import { useLang, scrollToId } from "../../site-context";
import { LINKS } from "../../i18n";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="border-t border-[#e3a008]/10 bg-[#080e1a] py-14" data-testid="footer">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center gap-8 text-center">
          <button onClick={() => scrollToId("inicio")} className="flex flex-col items-center gap-4">
            <img
              src="/assets/lion-mark.png"
              alt="Leão — Táxis Leão & Henrique"
              className="h-16 w-16 rounded-full ring-1 ring-[#e3a008]/40"
            />
            <span className="ff-display text-2xl font-semibold text-white" data-testid="footer-brand-title">
              Táxis Leão <span className="text-[#e3a008]">&</span> Henrique
            </span>
          </button>

          <p className="max-w-md text-sm font-light leading-relaxed text-slate-400">{t.footer_tagline}</p>

          <div className="ff-mono flex flex-wrap items-center justify-center gap-x-8 gap-y-3 text-xs uppercase tracking-widest text-slate-500">
            <a href={LINKS.phone} className="flex items-center gap-2 transition-colors hover:text-[#e3a008]" data-testid="footer-phone-link">
              <Phone className="h-3.5 w-3.5" /> {LINKS.phoneDisplay}
            </a>
            <a href={LINKS.phone2} className="flex items-center gap-2 transition-colors hover:text-[#e3a008]" data-testid="footer-phone2-link">
              <Phone className="h-3.5 w-3.5" /> {LINKS.phone2Display}
            </a>
            <a href={LINKS.email} className="flex items-center gap-2 transition-colors hover:text-[#e3a008]" data-testid="footer-email-link">
              <Mail className="h-3.5 w-3.5" /> {LINKS.emailDisplay}
            </a>
          </div>

          <div className="h-px w-full max-w-sm bg-gradient-to-r from-transparent via-[#e3a008]/30 to-transparent" />

          <p className="ff-mono text-[10px] uppercase tracking-[0.3em] text-slate-600">
            © {new Date().getFullYear()} Táxis Leão & Henrique · {t.footer_rights}
          </p>
        </div>
      </div>
    </footer>
  );
}
